const TabsHeader = ({ activeTab, setActiveTab, tabItems }: any) => {
  const tabWidth = 100 / tabItems.length;

  const getLeftPosition = () => {
    if (activeTab === 0) {
      return `calc(${activeTab * tabWidth}% + 5px)`;
    } else if (activeTab === tabItems.length - 1) {
      return `calc(${activeTab * tabWidth}% - 5px)`;
    }
    return `${activeTab * tabWidth}%`;
  };

  return (
    <div
      style={{ gridTemplateColumns: `repeat(${tabItems.length}, 1fr)` }}
      className={`w-full max-w-lg bg-pr_purple grid place-content-center h-[46px] rounded-lg relative`}
    >
      <div
        className={`absolute duration-500 top-[5px] h-[36px] bg-white zIndex-0 rounded-lg`}
        style={{
          width: `${tabWidth}%`,
          right: getLeftPosition(),
        }}
      ></div>

      {tabItems.map((tabItem: any) => (
        <h6
          key={tabItem.id}
          onClick={() => setActiveTab(tabItem.id)}
          className="cursor-pointer font-rokh font-[700] mt-1 text-center relative z-1 h-[46px] place-content-center"
        >
          {tabItem.title}
        </h6>
      ))}
    </div>
  );
};

export default TabsHeader;
